// note: dates are in PST
export const MAX_TRIAL_LENGTH_IN_DAYS = 30;

export const getMinTrialEndDate = (): Date => {
    const currentDate = new Date();
    const utcOffset = currentDate.getTimezoneOffset() * 60000;
    const pstOffset = -8 * 60 * 60000;
    const pstDate = new Date(currentDate.getTime() + utcOffset + pstOffset);
    return pstDate;
};

export const getMaxTrialEndDate = (inclusive: boolean = false): Date => {
    const currentDate = new Date();
    const utcOffset = currentDate.getTimezoneOffset() * 60000;
    const pstOffset = -8 * 60 * 60000;
    const offsetInDays = inclusive ? MAX_TRIAL_LENGTH_IN_DAYS + 1 : MAX_TRIAL_LENGTH_IN_DAYS;
    const pstDate = new Date(currentDate.getTime() + utcOffset + pstOffset + offsetInDays * 24 * 60 * 60000);
    return pstDate;
};

export const FTP_PASSWORD_MIN_LENGTH = 8;

export const FTP_PASSWORD_RULES =
    'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one number.';

// based on GeneratePasswordNoSpecialCharacters() from PasswordGenerator.cs in backend
export const generatePasswordFTP = (): string => {
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const numericalChars = '0123456789';

    // ensure at least one character from each set
    let password = '';
    const chars = [uppercaseChars, lowercaseChars, numericalChars];
    const randomOrder = chars.sort(() => Math.random() - 0.5);

    for (let i = 0; i < randomOrder.length; i++) {
        password += randomOrder[i].charAt(Math.floor(Math.random() * randomOrder[i].length));
    }

    // fill rest of the password with random characters
    for (let i = 3; i < FTP_PASSWORD_MIN_LENGTH; i++) {
        const allChars = uppercaseChars + lowercaseChars + numericalChars;
        password += allChars.charAt(Math.floor(Math.random() * allChars.length));
    }

    return password;
};

export const validatePasswordFTP = (password: string): boolean => {
    const uppercaseChars = /[A-Z]/;
    const lowercaseChars = /[a-z]/;
    const numericalChars = /[0-9]/;

    return (
        password.length >= FTP_PASSWORD_MIN_LENGTH &&
        uppercaseChars.test(password) &&
        lowercaseChars.test(password) &&
        numericalChars.test(password)
    );
};
